export const OPERATIONS = {
    MUL: "mul",
    DIV: "div",
};